import React from 'react';
import { MIDDLE_GRAY } from '~/Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';
import { FONT_SIZE_XXS } from '~/Constants/UI.constants';
import { LanguagesEnum } from '~/Constants/Languages.constants';
import { useLanguage } from '~/Hooks';
import { DATE_PICKER_DAY_WIDTH } from '~/Screens/Calendar/CalendarDatePicker/constants';

const useStyles = makeStyles({
  calendarWeekday: {
    color: MIDDLE_GRAY,
    fontSize: FONT_SIZE_XXS,
    overflow: 'hidden',
    maxWidth: DATE_PICKER_DAY_WIDTH,
    flexBasis: DATE_PICKER_DAY_WIDTH,
    textAlign: 'center',
    fontWeight: 'bold',
    lineHeight: '13px',
    paddingBottom: 8,
    letterSpacing: 0.33,
    textTransform: 'capitalize',
    textDecoration: 'none',
  },
});

export const CalendarDatePickerWeekDay = ({ dayOfWeek }: { dayOfWeek: string }) => {
  const { classes } = useStyles();
  const { currentLanguage } = useLanguage();
  return (
    <span className={classes.calendarWeekday} key={dayOfWeek}>
      {dayOfWeek?.substring(0, currentLanguage === LanguagesEnum.DE ? 2 : 1)}
    </span>
  );
};
